import {Box, IconButton, Modal, Typography, styled} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import {useRecoilState, useRecoilValue} from "recoil";
import {tipsModalState} from "../../Recoil/Atom/modalState";
import {userSelector, userState} from "../../Recoil/Atom/authState";

export const ModalBoxSize = styled(Box)(({theme}) => ({
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  backgroundColor: theme.palette.background.paper,
  border: "1px solid #444",
  boxShadow: theme.shadows[24],
}));

const WritingTipsModal = () => {
  const [isOpen, setIsOpen] = useRecoilState(tipsModalState);
  const user = useRecoilValue(userSelector);

  const handleClose = () => {
    setIsOpen(false);
  };
  return (
    <Modal open={isOpen} onClose={handleClose}>
      <ModalBoxSize>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "8px 0",
            backgroundColor: "#00579c",
          }}
        >
          <span></span>
          <Typography sx={{color: "#fff", fontWeight: "bold"}}>변경요청서 작성요령</Typography>
          <IconButton
            aria-label="delete"
            size="small"
            sx={{marginLeft: "32px"}}
            onClick={handleClose}
          >
            <CloseIcon sx={{color: "#fff"}} />
          </IconButton>
        </Box>
        <Box width={800} p="12px">
          <Box m="12px" p="12px" border="1px solid #cbddeb">
            {user.company.companyData.changeRequestTip1}
          </Box>
          <Box m="12px" p="12px" border="1px solid #cbddeb">
            {user.company.companyData.changeRequestTip1}
          </Box>
        </Box>
      </ModalBoxSize>
    </Modal>
  );
};

export default WritingTipsModal;
